<template>
  <div>
    <v-row align="center" no-gutters>
      <v-col v-if="!$vuetify.breakpoint.xs && !payWithFci" cols="12" sm="1">
        <v-btn @click="setQuotePaymentType(null)" class="ml-n1" icon>
          <v-icon>
            mdi-chevron-left
          </v-icon>
        </v-btn>
      </v-col>
      <v-col
        :class="!$vuetify.breakpoint.xs ? 'text-left' : 'text-center'"
        align-self="center"
        cols="12"
        sm="5"
      >
        <span class="d-block caption">
          {{ $t('quote.modal.payWith') }}
        </span>
        <span class="headline">
          {{ $t(`quote.modal.${type}`) }}
        </span>
      </v-col>
      <v-col
        :class="!$vuetify.breakpoint.xs ? 'text-right' : 'text-center'"
        align-self="center"
        cols="12"
        sm="6"
      >
        <span v-if="isCreditCardRentouNewVersion" class="display-1">
          {{ totalAmount ? formatMoney(totalAmount) : '---' }}
        </span>
      </v-col>
    </v-row>

    <v-divider class="mt-3 mb-4" />
  </div>
</template>

<script>
import { catalogMonetary } from '@/util/catalog'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'QuotePaymentHeader',

  props: {
    paymentType: {
      type: String,
    },
  },

  computed: {
    ...mapGetters(['quotes', 'quoteItems', 'payWithFci']),

    type() {
      return this.paymentType
    },

    version() {
      return this.quoteItems?.version
    },

    isCreditCardRentouNewVersion() {
      return this.version == 2 & this.paymentType != 'creditCard'
    },

    pixPaymentData() {
      if (this.quoteItems?.payment_options.length <= 0) return
      return this.quoteItems?.payment_options.find(({ payment_method }) => payment_method === 'ASAAS_PIX')
    },

    pixPaymentAmount() {
      if (!this.pixPaymentData?.total_value) return
      return this.formatMoney(this.pixPaymentData?.total_value)
    },

    pixToTotalAmount() {
      if (this.version != 2) return this.quotes.total
      else return this.pixPaymentAmount
    },

    pixTotal() {
      if (!this.quoteItems?.total) return
      return this.formatMoney(this.quoteItems?.total)
    },

    totalAmount() {
      switch (this.type) {
        case 'pix':
          return this.pixToTotalAmount
        case 'creditCard':
          return this.version != 2 && this.quotes.total_by_installments
        case 'fci':
          return this.quoteItems.net_fci
            ? this.quoteItems.net_fci
            : this.quotes.subtotal
      }
    },
  },

  data() {
    return {
      formatMoney: catalogMonetary,
    }
  },

  methods: {
    ...mapMutations(['setQuotePaymentType']),
  },
}
</script>
